module.exports = __webpack_public_path__ + "img/spec_detail_en_m.09442d8a.jpg";